import { CollectCreationForm } from 'components/Pages/ReverseLogistics';
import { Scaffold } from 'layouts';
import React, { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
// import { HomologAlert } from 'components/Shared'

export const CollectCreationPage: React.FC = () => {
  const navigate = useNavigate();

  const onCreate = useCallback((): void => {
    navigate('/logistica-reversa/coletas');
  }, [navigate]);

  return (
    <Scaffold>
      {/* <HomologAlert /> */}
      <CollectCreationForm onCreate={onCreate} />
    </Scaffold>
  );
};
